<script>
  import ImageProductCard from './ImageProductCard.svelte';
  import trackClick from '../events/trackClick';
  import { onMount } from 'svelte';
  import addToBasket from '../events/addToBasket';
  import Rating from './Rating.svelte';
  import Price from './Price.svelte';

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

  /*                */
  let {
    position,
    recommendation,
    featureIndex,
    widgetTracking,
    widgetAdditionalClickTracking,
    add2basketErrorCallback = () => {},
    pageName,
    observeCard = () => {}
  } = $props();
  let thisCard = $state();

  const {
    _embedded: { 'o:variation': variation },
    brandName,
    formattedPrice,
    image,
    tracking,
    additionalClickTracking
  } = recommendation;

  let add2basketButtonClicked = $state(false);

  const variationDetailViewUrl = variation._links['o:detail-view']?.href;
  const baseDetailViewUrl = variation._links['o:base-detail-view-url']?.href;
  const conditionalBaseDetailViewUrl = !baseDetailViewUrl ? {} : { href: baseDetailViewUrl };
  const linkElementTag = !baseDetailViewUrl ? 'span' : 'a';

  const add2basketClickListener = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!add2basketButtonClicked) {
      add2basketButtonClicked = true;
      addToBasket(variation.id, widgetAdditionalClickTracking, additionalClickTracking, pageName);
    }
  };

  onMount(() => {
    observeCard(thisCard, tracking, position);
    o_global.eventQBus.on('ft1.order-core.addToBasketResult', ({ variationId, successful }) => {
      if (variationId !== variation.id) {
        return;
      }
      add2basketButtonClicked = !!successful;
      if (!successful) {
        add2basketErrorCallback();
      }
    });
  });

  const viewProductListener = () => {
    trackClick(
      widgetTracking,
      widgetAdditionalClickTracking,
      tracking,
      additionalClickTracking,
      featureIndex,
      pageName
    );
  };
</script>

<oc-link-v2 variant="secondary" base64-href={btoa(variationDetailViewUrl)}>
  <svelte:element
    this={linkElementTag}
    class="reco_aos_product_card__link"
    {...conditionalBaseDetailViewUrl}
    data-testid="reco_link_{variation.name}"
    onclick={viewProductListener}
    bind:this={thisCard}
    data-tracking={`{"promo_Source":"${tracking?.labels?.promo_Source}"}`}>
    <div class="reco_aos_product_card" data-testid="reco_aos_product_card">
      <div class="reco_aos_product_card__left_side">
        <ImageProductCard {image} description={variation.name} />
        <div>
          <div class="reco_aos_product_card__name">
            {brandName}
            {variation.name}
          </div>
          <Rating {variation} />
          <!--svelte-ignore a11y_click_events_have_key_events-->
          <!--svelte-ignore a11y-no-static-element-interactions-->
          <oc-button-v1
            size="50"
            type="button"
            icon-type-left="basket"
            class="reco_aos_product_card__button"
            class:clicked={add2basketButtonClicked}
            onclick={add2basketClickListener}>
            <div class="overlay">
              <oc-icon-v1 type="check" size="50" style="margin-top: 10px;"></oc-icon-v1>
            </div>
            <span>Hinzufügen</span>
          </oc-button-v1>
        </div>
      </div>

      <div class="reco_aos_product_card__right_side">
        <Price {formattedPrice}></Price>
      </div>
    </div>
  </svelte:element>
</oc-link-v2>

<style lang="scss">
  .reco_aos_product_card {
    padding: 24px 0;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    justify-content: space-between;
  }

  .reco_aos_product_card__link {
    text-decoration: none;
    color: black;
  }

  .reco_aos_product_card__link:hover {
    text-decoration: grey underline;
  }

  .reco_aos_product_card__left_side {
    display: flex;
  }

  .reco_aos_product_card__right_side {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;
    margin-left: var(--oc-semantic-spacing-100);
  }

  .reco_aos_product_card__name {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow-wrap: anywhere;
    font: var(--oc-semantic-font-copy-75);
  }

  .reco_aos_product_card__button {
    margin-top: 16px;

    .overlay {
      background-color: #50cc7f;
      width: 100%;
      height: 100%;
      position: absolute;
      border-radius: 8px;
      opacity: 0;
      transition: opacity 0.2s 0.2s;
    }

    span {
      transition: opacity 0.2s 0.4s;
    }

    &.clicked {
      cursor: default;

      .overlay {
        opacity: 1;
        transition: opacity 0.2s 0.2s;
        left: 0px;
        top: 0px;
      }

      span {
        opacity: 0;
        transition: opacity 0.2s;
      }
    }
  }

  .reco_aos_product_card:last-child {
    border-bottom: none;
    padding: 24px 0 0 0;
  }
</style>
